import ApiConfig from '@/server-config/domain.config'
export default function ({
  $gtm,
  route
}) {
  $gtm.init(ApiConfig.GTM_ID ? ApiConfig.GTM_ID : '') // pass gtm id as a varibale form different env
}
